const wrapper = "_35swwkpqjc";

export { wrapper };
import "./_task.radio-button.style.linaria.module.css";
//# sourceMappingURL=_task.radio-button.style.js.map
